/* @flow */
export const validation = {
  titleMaxChar: 200,
  paragraphMaxChar: 2000,
  buttons: {
    min: 0,
    max: 2
  }
}
